import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  ComponentRef,
  Input,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { AsyncInsertionPointDirective } from '../directives/async-insertion-point.directive';
import { EmployeeWithBadgeComponent } from './employee-with-badge/employee-with-badge.component';
import Employee from 'src/app/model/product/employee';

@Component({
  selector: 'async-employee-with-badge',
  templateUrl: './async-employee-with-badge.component.html',
  styleUrls: ['./async-employee-with-badge.component.scss'],
})
export class AsyncEmployeeWithBadge implements AfterViewInit {
  @Input()
  employee: Employee;
  @Input()
  svgIcon: string;
  @Input()
  transformClass: string;
  @Input()
  borderColor: string;
  @Input()
  locationVerification: boolean = false;

  @ViewChild(AsyncInsertionPointDirective, { static: true })
  asyncInsertionPoint: AsyncInsertionPointDirective;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private cd: ChangeDetectorRef
  ) {}

  ngAfterViewInit(): void {
    const componentFactory =
      this.componentFactoryResolver.resolveComponentFactory(
        EmployeeWithBadgeComponent
      );

    const viewContainerRef = this.asyncInsertionPoint.viewContainerRef;
    viewContainerRef.clear();

    const componentRef = componentFactory.create(
      viewContainerRef.parentInjector
    );
    componentRef.instance.employee = this.employee;
    componentRef.instance.svgIcon = this.svgIcon;
    componentRef.instance.transformClass = this.transformClass;
    componentRef.instance.borderColor = this.borderColor;
    componentRef.instance.locationVerification = this.locationVerification;

    setTimeout(() => this.initSvgIcon(componentRef, viewContainerRef), 100);
  }

  initSvgIcon(
    componentRef: ComponentRef<EmployeeWithBadgeComponent>,
    viewContainerRef: ViewContainerRef
  ) {
    viewContainerRef.insert(componentRef.hostView);
    this.cd.detectChanges();
  }
}
